export default __webpack_public_path__ + "static/media/pic4.bc8c84c8.jpg";